import { memo } from 'react'
import { X } from 'lucide-react'

interface Props {
  open: boolean
  onClose: () => void
}

/**
 * Placeholder для D2: отображает статус подписки.
 * Renewal flow + client-signed payment-intent — в D4-D5.
 */
export const PlanDialog = memo(function PlanDialog({ open, onClose }: Props) {
  if (!open) return null

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center"
      role="dialog"
      aria-modal="true"
      aria-labelledby="plan-title"
    >
      <button
        type="button"
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onClose}
        aria-label="Закрыть"
      />
      <div className="relative z-10 w-full max-w-md rounded-xl border border-[#374151] bg-[#111827] p-5 shadow-xl">
        <div className="mb-4 flex items-center justify-between">
          <h2 id="plan-title" className="text-lg font-semibold text-white">Подписка</h2>
          <button
            type="button"
            onClick={onClose}
            className="rounded p-1 text-[#94a3b8] hover:bg-white/10 hover:text-white"
            aria-label="Закрыть"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
        <div className="rounded-lg border border-[#374151] bg-[#1f2937] px-3 py-3 text-sm text-[#e2e8f0]">
          <div className="mb-1 font-semibold">PolyStrike Visual</div>
          <div className="text-[#94a3b8]">8.5 USDC / 30 дней</div>
          <div className="mt-3 text-[11px] text-[#64748b]">
            Интерфейс продления подписки — скоро. Первая активация — 7-дневный trial
            автоматически при подключении PM-кошелька.
          </div>
        </div>
      </div>
    </div>
  )
})
